import { PayflowProgressBarWidgetContent } from './PayflowProgressBarWidgetContent';
import type { PayflowProgressBarWidgetProps } from './usePayflowProgressBarWidget';
import { WithStatusHandling } from '../WithStatusHandling';

export const PayflowProgressBarWidget = ({ status, handlers, data, hooks }: PayflowProgressBarWidgetProps) => {
  return (
    <WithStatusHandling
      skeletonHeight={88}
      status={status}
      errorMessage={status === 'error' ? data.message : undefined}
      retry={status === 'error' ? handlers.retry : undefined}
    >
      {status === 'loaded' && <PayflowProgressBarWidgetContent data={data} handlers={handlers} hooks={hooks} />}
    </WithStatusHandling>
  );
};
